const Title = () => {
  return (
    <span className="text-3xl	sm:text-5xl	color text-mainWhite font-700 w-full text-center lg:text-left">
      Vesting manager
    </span>
  );
};

export default Title;
